import { gql } from '@apollo/client';

export const UPSERT_COMMUNITY_GROUP_WORKFLOWS = gql`
  mutation UpsertCommunityGroupWorkflows($communityGroupId: ID!, $type: String!, $input: UpsertCommunityGroupWorkflowConfigurationInput!) {
    upsertCommunityGroupWorkflowConfiguration(communityGroupId: $communityGroupId, type: $type, input: $input) {
      type
      topicActions {
        topicName
        actionNames
      }
    }
  }
`;
